import styled from "styled-components";
import { colors } from "../../../styles/style";
import { MilestoneCard } from "../../feed/common/MilestoneCard";
import { useNavigate } from "react-router-dom";
import { HeaderText } from "../../shared/SharedStyles";
import { milestonesData } from "../../../common/constants";
import { canUseFeature, featureForPath } from "../../../common/plan";
import { useBabyContext } from "../../../context/BabyContext";

export const AllMilestones = () => {
  const navigate = useNavigate();
  /* The baby's entitlement, not the caller's — an invited grandparent must see
     a paid baby unlocked. */
  const { babyHasActivePayment } = useBabyContext();

  const isLocked = (url: string) => {
    const feature = featureForPath(url);
    return feature ? !canUseFeature(feature, babyHasActivePayment) : false;
  };

  /* Locked cards still navigate. The page itself shows what is behind the
     lock, blurred, which is the whole point of showing the card at all. */
  const handleClick = (url: string) => {
    navigate(url);
  };
  return (
    <Container>
      <ContainerHeader>
        <HeaderText>All Milestones</HeaderText>
      </ContainerHeader>
      <AllMilestonesContainer>
        {milestonesData.map((milestone, index) => (
          <MilestoneCard
            key={index}
            $icon_src={milestone.iconSrc}
            title={milestone.title}
            width="auto"
            $max_width=""
            $min_width="100px"
            onClick={() => handleClick(milestone.url)}
            $bgColor={isLocked(milestone.url) ? colors.lightPeach : ""}
            isNew={milestone.isNew}
            isLocked={isLocked(milestone.url)}
          />
        ))}
      </AllMilestonesContainer>
    </Container>
  );
};

const Container = styled.div`
  flex-grow: 1;
  padding: 24px;
  border-radius: 32px;
  background: ${colors.bgWhite};
  padding-bottom: 100px;
`;
const ContainerHeader = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 30px;
`;
const AllMilestonesContainer = styled.div`
  flex-grow: 1;
  display: grid;
  grid-template-columns: repeat(2, 1fr); /* Two columns with equal width */
  gap: 12px;
`;
